import './AppLoader.scss';
import Logo from 'assets/images/logo.svg';
function AppLoader() {
	return (
		<div className="AppLoader">
			<div className="loader-circle"></div>
			<div className="loader-line-mask">
				<div className="loader-line"></div>
			</div>
			<img alt="ThanosLogo" src={Logo} />
		</div>
	);
}
export default AppLoader;
